import { useOsRoot } from 'providers/osRoot/OsRootContext'
import { HostType } from 'types/tenants/tenant'
import { routesManager } from 'utils/routesManager'

export const useDefaultLoginRedirectUrl = () => {
  const { hostInfo } = useOsRoot()

  return hostInfo.type === HostType.TENANT ? '/' : routesManager.generic.root.url()
}
